import { Button } from '@vnetwork/ui/primitives';

/** Small retry button for tab error states. */
export function TabRetry({ onRetry }: { onRetry: () => void }) {
  return (
    <Button size="sm" variant="ghost" onClick={onRetry}>
      Retry
    </Button>
  );
}
